module.exports = __webpack_public_path__ + "static/media/rare.de5db37b.png";